import React from 'react';

const TooltipPopover = ({ children, coords, updateTooltipCoords }) => {
  // const updateCoords = debounce(updateTooltipCoords, 100);
  // const updateCoords = updateTooltipCoords;

  // useEffect(() => {
  //   window.addEventListener("resize", updateCoords);
  //   return () => window.removeEventListener("resize", updateCoords);
  // }, []);

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        ...styles.popover,
        ...coords,
      }}
    >
      {children}
    </div>
  );
};

const styles = {
  popover: {
    position: 'absolute',
    zIndex: 200,
  },
};

export default TooltipPopover;
